export default "__VITE_ASSET__w941JCWF__"